import { type Writable, writable } from 'svelte/store';

import { type IProfile } from '@shared/models';

export const activeProfile: Writable<IProfile | null> = writable(null);
